<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn text medium icon v-bind="attrs" v-on="on">
          <v-icon medium color="white lighten-1"> mdi-plus-circle </v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Cadastro de Tombo</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="asset_form">
              <v-row>
                <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                  <v-text-field
                    v-model="$v.form.asset_number.$model"
                    v-mask="'#########'"
                    label="Numero de Tombo*"
                    color="red lighten-1"
                    required
                    :error-messages="errors.data.asset_number"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                  <v-text-field
                    v-model="$v.form.serial_number.$model"
                    label="Numero de Serie*"
                    color="red lighten-1"
                    required
                    :error-messages="errors.data.serial_number"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                  <v-select
                    v-model="$v.form.condition_id.$model"
                    hide-details
                    :items="conditions"
                    item-value="id"
                    item-text="choice"
                    label="Condição do Equipamento*"
                    :error-messages="errors.data.condition_id"
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                  <v-file-input
                    v-model="$v.form.images.$model"
                    prepend-icon="mdi-camera"
                    accept="image/png, image/jpeg, image/bmp, image/jpg"
                    label="Fotos do Item*"
                    color="red lighten-1"
                    placeholder="Insira imagens para comprovar o estado do item."
                    multiple
                    show-size
                    chips
                    :error-messages="errors.data.images"
                  ></v-file-input>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <small>*Indica Campos Obrigátorios</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" text @click="close()"> Fechar </v-btn>
          <v-btn color="black" text @click="storeAsset()"> Salvar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { mask } from 'vue-the-mask'

export default {
  name: 'FormCreateAsset',
  props: { itemId: Number },
  directives: { mask },
  data: () => ({
    acquisitions_treated: {},
    dialog: false,
    form: {
      asset_number: '',
      condition_id: '',
      serial_number: '',
      images: [],
    },
    errors: {
      messages: {
        required: 'O campo e obrigatorio',
      },
      data: {
        asset_number: [],
        condition_id: [],
        serial_number: [],
        images: [],
      },
    },
  }),
  validations: {
    form: {
      asset_number: { required },
      condition_id: { required },
      serial_number: { required },
      images: {},
    },
  },
  computed: {
    ...mapState('conditions', ['conditions']),
  },
  methods: {
    ...mapActions('ui', ['ActionSetLoading']),
    ...mapActions('assets', ['ActionStoreAsset']),
    async storeAsset() {
      this.ActionSetLoading(true)

      try {
        this.$v.$touch()
        Object.keys(this.errors.data).forEach((key) => {
          this.errorMensage(key)
        })
        if (!this.$v.$invalid) {
          let treated_form = new FormData()
          treated_form.append('invoice_item_id', this.itemId)
          treated_form.append('asset_number', this.form.asset_number)
          treated_form.append('condition_id', this.form.condition_id)
          treated_form.append('serial_number', this.form.serial_number)
          for (let index = 0; index < this.form.images.length; index++) {
            treated_form.append('images[' + index + ']', this.form.images[index])
          }

          await this.ActionStoreAsset(treated_form)
          this.$swal({
            icon: 'success',
            title: 'Cadastrado',
            text: 'Recurso tombado com sucesso',
          })
          this.close()
        }
      } catch (error) {
        if (error.body) {
          if (error.status != 422) {
            this.$swal({
              icon: 'error',
              title: 'Erro',
              text: error.body.message,
            })
          }
          if (error.body.errors) {
            Object.keys(error.body.errors).map((key) => {
              this.errors.data[key] = error.body.errors[key]
            })
          }
        }
      }

      this.ActionSetLoading(false)
    },
    close() {
      this.$refs.asset_form.reset()
      this.dialog = false
    },
    errorMensage(key) {
      const errors = []
      if (key == 'id') return
      if (!this.$v.form[key].$dirty) return errors

      if (this.$v.form[key].required !== undefined)
        !this.$v.form[key].required && errors.push(this.errors.messages.required)

      if (this.$v.form[key].minLength !== undefined)
        !this.$v.form[key].minLength &&
          errors.push(this.errors.messages.minLength(this.$v.form[key].$params.minLength.min))

      if (this.$v.form[key].maxLength !== undefined)
        !this.$v.form[key].maxLength &&
          errors.push(this.errors.messages.maxLength(this.$v.form[key].$params.maxLength.max))

      if (this.$v.form[key].email !== undefined)
        !this.$v.form[key].email && errors.push(this.errors.messages.email)

      this.errors.data[key] = errors
    },
  },
}
</script>
